<template>
  <v-dialog
    class='risk-score-filter-popup'
    :value="visiblePopup"
    :max-width="600"
    @click:outside="onNoClickButton()"
    @keydown.esc="onNoClickButton()"
  >
    <v-card class="popup-wrapper">
      <div class="title">{{$t(title)}}</div>
      <div class='risk-score-wrapper'>
        <v-range-slider
          v-model="riskScoreUpdatedValue"
          :max="maxValue"
          :min="minValue"
          step="0.1"
          hide-details
          class="align-center"
        >
          <template v-slot:prepend>
            <v-text-field
              v-model="riskScoreUpdatedValue[0]"
              hide-details
              single-line
              type="number"
              variant="outlined"
              density="compact"
              class="slider-value"
            ></v-text-field>
          </template>
          <template v-slot:append>
            <v-text-field
              v-model="riskScoreUpdatedValue[1]"
              hide-details
              single-line
              type="number"
              variant="outlined"
              class="slider-value"
              density="compact"
            ></v-text-field>
          </template>
        </v-range-slider>
      </div>
      <div class="buttons">
        <v-btn v-if='showNoButton' small depressed class="no-button btn-secondary" @click="onNoClickButton()">
          {{$t(noCaption)}}
        </v-btn>
        <v-btn small depressed class="yes-button btn-primary" @click="onYesClickButton()">
          {{$t(yesCaption)}}
        </v-btn>
      </div>
    </v-card>
  </v-dialog>

</template>

<script>
import disableOuterScrollOnPopupVisible from '@/mixins/disableOuterScrollOnPopupVisible';

export default {
  name: 'SelectRiskScoreFilterPopup',
  mixins: [disableOuterScrollOnPopupVisible],
  props: {
    title: String,
    yesCaption: String,
    noCaption: String,
    showNoButton: {
      type: Boolean,
      default: true,
      required: false,
    },
    visiblePopup: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      riskScoreUpdatedValue: [0, 100],
    };
  },
  watch: {
    visiblePopup() {
      this.riskScoreUpdatedValue = [0, 100];
    },
  },
  methods: {
    onYesClickButton() {
      this.$emit('clicked', this.riskScoreUpdatedValue);
    },
    onNoClickButton() {
      this.$emit('clicked', false);
    },
  },
  computed: {
    minValue() {
      return 0;
    },
    maxValue() {
      return 100;
    },
  },
};
</script>

<style lang='scss'>
@import '~@/assets/styles/design-system';
.risk-score-wrapper {
  .v-text-field {
    margin-top: 0px !important;
  }
}
</style>

<style lang="scss" scoped>
@import '~@/assets/styles/design-system';
.popup-wrapper {
  max-width: rem(600);
  min-width: rem(600);
  padding: rem(32) rem(40);
  .risk-score-wrapper {
    min-width: rem(400);
    margin-bottom: rem(-20);
    .slider-value {
      width: rem(50);
      margin-bottom: rem(15);
    }
  }

  .title {
    color: var(--text-primary);
    font-size: rem(14) !important;
    font-weight: 600;
    letter-spacing: rem(1.12);
    line-height: rem(16);
    text-transform: uppercase;
    padding-bottom: rem(23);
  }

  .buttons {

    text-align: right;
    padding-top: rem(30);

    .no-button {
      box-sizing: border-box;
      height: rem(32);
      width: rem(86);
      border: 1px solid var(--brand-primary);
      color: var(--brand-primary);
      border-radius: $radius-sm;
      background-color: var(--bg-primary);
      box-shadow: 0 1px 1px 0 rgba(0,0,0,0.14), 0 2px 1px -1px rgba(0,0,0,0.12),
      0 1px 3px 0 rgba(0,0,0,0.2) !important;
    }

    .yes-button {
      height: rem(32);
      width: rem(51);
      border-radius: $radius-sm;
      box-shadow: $shadow-sm;
      font-size: rem(12);
      font-weight: 500;
      letter-spacing: rem(1.07);
      line-height: rem(16);
      text-align: center;
      margin-left: rem(8);
    }

  }
}

</style>
